export class GetErpOrderNFeInput {
    orderId: number;
    erpOrderCode: number;
    collectOrder: boolean;
    userId?: number;
}